import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { COLORS, FONT } from "../../constants";
import TC_CLAUSES from "./tcText";

const TermsAndConditionsStep = ({ tcAgreed, setTcAgreed, isMobile }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Typography
        sx={{
          fontSize: FONT.size.xs,
          fontWeight: 600,
          color: COLORS.darkText,
          letterSpacing: 0.5,
          mb: 1.5,
          textTransform: "uppercase",
        }}
      >
        Terms and Conditions of Sale
      </Typography>

      <Box
        sx={{
          overflowY: "auto",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          p: 2.5,
          backgroundColor: "#fafafa",
          maxHeight: 440,
          mb: 2,
        }}
      >
        {TC_CLAUSES.map((clause) => (
          <Typography
            key={clause.id}
            sx={{
              fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
              color: COLORS.darkText,
              lineHeight: 1.85,
              mb: 1.5,
              pl: clause.indent ? 2 : 0,
              textAlign: "justify",
            }}
          >
            {(() => {
              const space = clause.text.indexOf(" ");
              const num = clause.text.slice(0, space);
              const body = clause.text.slice(space);
              return (
                <>
                  <Box component="span" sx={{ fontWeight: 700 }}>
                    {num}
                  </Box>
                  {body}
                </>
              );
            })()}
          </Typography>
        ))}
      </Box>

      <FormControlLabel
        sx={{ mb: 2, alignItems: "flex-start" }}
        control={
          <Checkbox
            checked={tcAgreed}
            onChange={(e) => setTcAgreed(e.target.checked)}
            size="small"
            sx={{
              pt: 0,
              color: "#cccccc",
              "&.Mui-checked": { color: COLORS.themeRed },
            }}
          />
        }
        label={
          <Typography
            sx={{ fontSize: FONT.size.xs, color: COLORS.darkText, lineHeight: 1.6 }}
          >
            I have read and agree to the Terms and Conditions of Sale above.
            <Box component="span" sx={{ color: COLORS.themeRed, ml: 0.25 }}>
              *
            </Box>
          </Typography>
        }
      />

    </Box>
  );
};

export default TermsAndConditionsStep;
